import React, { useState } from "react";
import PropTypes from "prop-types";
import Alert from "@material-ui/lab/Alert";

import BotonAtras from "./components/BotonAtras";
import GridOpciones from "./components/GridOpciones";
import { EstadoVacio } from "./components/Estados";
import SolicitudForm from "./forms/SolicitudForm";

import { SOLICITUDES } from "./catalogo";
import { perfilDe, puedeSolicitar } from "./model/permisos";
import { guardarSolicitud, obtenerHorarioSolicitudes } from "./services/bibliotecaApi";
import { useConsulta } from "./hooks/useConsulta";

/**
 * Catalogo de tipos de solicitud. Solo enseña los que el perfil activo puede
 * crear; la regla esta en model/permisos.js.
 *
 * Elegir un tipo abre su formulario en un modal, encima de las tarjetas, como
 * la Solicitud de grado; al cerrarlo, las tarjetas siguen ahi.
 *
 * Fuera del horario para radicar se avisa y no se abre el formulario: el
 * backend lo rechazaria al final, despues de llenarlo todo.
 */
const ProcesosAprendizaje = ({ usuario, volver, onMensaje, onCreada }) => {
  const [solicitud, setSolicitud] = useState(null);
  // Si falla la consulta no se bloquea: el backend vuelve a revisar.
  const { datos: horario } = useConsulta(obtenerHorarioSolicitudes, [], null);
  const cerrado = horario && !horario.puede_radicar;
  const avisoCerrado = `Fuera del horario para radicar. Las solicitudes se radican ${horario?.radicar.texto}.`;

  const perfil = perfilDe(usuario);
  const disponibles = SOLICITUDES.filter(({ codigo }) =>
    puedeSolicitar(perfil, codigo),
  );

  // Devuelve si se guardo, para que el formulario sepa si reactivar el boton.
  const onGuardar = async (payload) => {
    const { ok, titulo, estado } = await guardarSolicitud(payload);

    // 302 es un error de negocio (dato invalido, sin cupo...); cualquier otro
    // codigo, o ninguno, es una falla del servidor o de la conexion.
    const tipoMensaje = ok ? "success" : estado === 302 ? "info" : "error";
    onMensaje(titulo, tipoMensaje);

    if (ok) {
      setSolicitud(null);
      onCreada();
    }
    return ok;
  };

  return (
    <div>
      <BotonAtras onClick={volver} />

      {disponibles.length === 0 ? (
        <EstadoVacio mensaje="No tienes solicitudes disponibles para tu perfil" />
      ) : (
        <>
          {cerrado && (
            <Alert severity="warning" style={{ margin: "8px 16px" }}>
              {avisoCerrado}
            </Alert>
          )}
          <GridOpciones
            opciones={disponibles}
            onSeleccionar={(opcion) => (cerrado ? onMensaje(avisoCerrado, "info") : setSolicitud(opcion))}
          />
        </>
      )}

      {solicitud && (
        <SolicitudForm
          tipo={solicitud.codigo}
          titulo={solicitud.nombre}
          usuario={usuario}
          onCerrar={() => setSolicitud(null)}
          onGuardar={onGuardar}
          onMensaje={onMensaje}
        />
      )}
    </div>
  );
};

ProcesosAprendizaje.propTypes = {
  volver: PropTypes.func.isRequired,
  usuario: PropTypes.object,
  onMensaje: PropTypes.func,
  // Se llama cuando la solicitud se guardo (p. ej. para ir a Procesos).
  onCreada: PropTypes.func,
};

ProcesosAprendizaje.defaultProps = {
  onMensaje: () => {},
  onCreada: () => {},
};

export default ProcesosAprendizaje;
